module.exports = __webpack_public_path__ + "fonts/OpenSans-Regular.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/common/fonts/Open_Sans/OpenSans-Regular.ttf
// module id = 3484
// module chunks = 0